<div class="modal-body">
  <div class="card">
    <div class="card-header modal-card-header mt-2">
      <h4 class="form-section">
        <i class="ft-settings"></i> {{ 'settings.title' | translate }}
      </h4>
    </div>
    <div class="card-body">
      <div class="px-3">
        <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onTabChange($event.nextId)">

          <!-- Email Settings -->
          <li *ngIf="hasEmailSettingsViewPermission" ngbNavItem="email">
            <a ngbNavLink><i class="ft-mail"></i> {{ 'settings.emailTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-email-settings></app-email-settings>
            </ng-template>
          </li>

          <!-- SMS Settings -->
          <li *ngIf="hasSmsSettingsViewPermission" ngbNavItem="sms">
            <a ngbNavLink><i class="icon-envelope-letter"></i> {{ 'settings.smsTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-sms-settings></app-sms-settings>
            </ng-template>
          </li>

          <!-- IbanXS Settings -->
          <li *ngIf="hasIbanXSSettingsViewPermission" ngbNavItem="ibanxs">
            <a ngbNavLink><i class="icon-key"></i> {{ 'settings.ibanXSTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-ibanxs-settings></app-ibanxs-settings>
            </ng-template>
          </li>

          <!-- Cron job Settings -->
          <li *ngIf="hasCronJobSettingsViewPermission" ngbNavItem="cron-job">
            <a ngbNavLink><i class="ft-clock"></i> {{ 'settings.cronJobTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-cron-job-settings></app-cron-job-settings>
            </ng-template>
          </li>

          <!-- Company Info Settings -->
          <li *ngIf="hasCompanyInfoSettingsViewPermission" ngbNavItem="company-info">
            <a ngbNavLink><i class="ft-info"></i> {{ 'settings.companyInfoTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-company-info-settings></app-company-info-settings>
            </ng-template>
          </li>

          <!-- RDW Car Data Settings -->
          <li *ngIf="hasRdwCarDataSettingsViewPermission" ngbNavItem="rdw-cardata">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.rdwCarDataTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-rdw-cardata-settings></app-rdw-cardata-settings>
            </ng-template>
          </li>

          <!-- VAT Number Verification Settings -->
          <li *ngIf="hasVatNumberVerificationSettingsViewPermission" ngbNavItem="vatnumber-verification">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.vatNumberVerificationTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-vatnumber-verification-settings></app-vatnumber-verification-settings>
            </ng-template>
          </li>

          <!-- Chamber Of Commerce Settings -->
          <li *ngIf="hasChamberOfCommerceSettingsViewPermission" ngbNavItem="chamber-of-commerce">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.chamberOfCommerceTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-chamber-of-commerce-settings></app-chamber-of-commerce-settings>
            </ng-template>
          </li>

          <!-- Business Support Settings -->
          <li *ngIf="hasBusinessSupportSettingsViewPermission" ngbNavItem="business-support">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.businessSupportTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-business-support-settings></app-business-support-settings>
            </ng-template>
          </li>

          <!-- Central Insolvency Register Settings -->
          <li *ngIf="hasCentralInsolvencyRegisterSettingsViewPermission" ngbNavItem="central-insolvency-register">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.centralInsolvencyRegisterTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-central-insolvency-register-settings></app-central-insolvency-register-settings>
            </ng-template>
          </li>

          <!-- Signhost Settings -->
          <li *ngIf="hasSignhostSettingsViewPermission" ngbNavItem="signhost">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.signhostTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-signhost-settings></app-signhost-settings>
            </ng-template>
          </li>

          <!-- Parble Settings -->
          <li *ngIf="hasParbleSettingsViewPermission" ngbNavItem="parble">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.parbleTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-parble-settings></app-parble-settings>
            </ng-template>
          </li>

          <!-- Exact Online Settings -->
          <li *ngIf="hasExactOnlineSettingsViewPermission" ngbNavItem="exact-online">
            <a ngbNavLink><i class="ft-settings"></i> {{ 'settings.exactOnlineTitle' | translate }} </a>
            <ng-template ngbNavContent>
              <app-exact-online-settings></app-exact-online-settings>
            </ng-template>
          </li>

          <!-- DocumentIntelligence Settings -->
          <li *ngIf="hasDocumentIntelligenceSettingsViewPermission" ngbNavItem="document-intelligence">
            <a ngbNavLink><i class="ft-settings"></i> {{'settings.documentIntelligenceTitle' | translate}} </a>
            <ng-template ngbNavContent>
              <app-document-intelligence-settings></app-document-intelligence-settings>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>

        <div class="form-actions">
        </div>
      </div>
    </div>
  </div>
</div>
